import { useState } from 'react';
import { Box } from '@mui/material';

import CardContainer from '../SideColumnsContent/CardContainer/CardContainer';
import PollController from './PollController';
import PollExtras from './PollExtras/PollExtras';
import PollOptions from './PollOptions/PollOptions';
import PollTitle from './PollTitle/PollTitle';
import { PollRecord } from '../../models/Poll';
import PollComments from './PollComments/PollComments';

export const MIN_VOTES_TO_DISPLAY = 50;

interface PollProps {
    poll: PollRecord;
    mypoll?: boolean;
    bottomComponent?: JSX.Element;
}

const Poll = (props: PollProps): JSX.Element => {
    const [poll, setPoll] = useState<PollRecord>(
        PollController.forceOptionVotes(props.poll),
    );
    const [showComments, setShowComments] = useState<boolean>(false);

    return (
        <CardContainer className='poll-card-container'>
            <PollTitle key={poll.id}>{poll.title}</PollTitle>
            {/* HP1 */}
            {poll.description && (
                <Box className='poll-description'>{poll.description}</Box>
            )}
            <PollOptions
                poll={poll}
                setPoll={setPoll}
                mypoll={Boolean(props.mypoll)}
            />
            <PollExtras
                poll={poll}
                mypoll={Boolean(props.mypoll)}
                bottomComponent={props.bottomComponent}
                showComments={showComments}
                setShowComments={setShowComments}
            />
            {showComments && <PollComments poll={poll} setPoll={setPoll} />}
        </CardContainer>
    );
};

export default Poll;
